<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-9">
				<sf-card class="p-0 h-100 card_bg">
					<pc-pcm-regn-search ref="search" :scrId="scrId"></pc-pcm-regn-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-pcm-regn-table
						ref="table"
						:scrId="scrId"
						:tab1="getMessage_('QWCC001755')"
						:tab2="getMessage_('QWCC001756')"
						:tab3="getMessage_('QWCC001757')"
					></pc-pcm-regn-table>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcmRegn/store/helpers';
import PcPcmRegnSearch from './Search/PcPcmRegnSearch.vue';
import PcPcmRegnTable from './Table/PcPcmRegnTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: { PcPcmRegnSearch, PcPcmRegnTable },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		Refresh() {
			this.$refs.search.searchList();
		}
	}
};
</script>

<style></style>
